import { createContext, useReducer } from "react";
import { useEffect } from "react";
const INITIAL_STATE = {
    user: JSON.parse(localStorage.getItem("user")) || null,
    load: false,
    error: null,
  };
  
  export const AuthContext = createContext(INITIAL_STATE);
  
  const AuthReducer = (state, action) => {
    switch (action.type) {
      case "LOGIN_START":
        return {
          user: null,
          load: true,
          error: null,
        };
      case "LOGIN_SUCCESS":
        return {
          user: action.payload,
          load: false,
          error: null,
        };
      case "LOGIN_FAILURE":
        return {
          user: null,
          load: false,
          error: action.payload,
        };
        case "LOGIN_SIGNUP":
          return {
            user: null,
            load: true,
            error: action.payload,
          };
      case "LOGOUT":
        return {
          user: null,
          load: false,
          error: null,
        };
      default:
        return state;
    }
  };
  
  export const AuthContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(AuthReducer, INITIAL_STATE);
  
    useEffect(() => {
      localStorage.setItem("user", JSON.stringify(state.user));
    }, [state.user]);
  
    return (
      <AuthContext.Provider
        value={{
          user: state.user,
          load: state.load,
          error: state.error,
          dispatch,
        }}
      >
        {children}
      </AuthContext.Provider>
    );
  };